import React from 'react';
import { PageHeader } from 'antd';
import { MyBreadcrumb } from 'utils';
import CompaniesForm from './form';
export default function CompaniesCreate() {

    return (
        <div>
            <MyBreadcrumb items={[{ label: "Companies", path: "/companies" }, { label: "Create", path: "" }]} />
            <PageHeader
                ghost={false}
                onBack={() => window.history.back()}
                title="Create"
                subTitle=""
            >
                <CompaniesForm />
            </PageHeader>
        </div>
    );
}